import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  return {
    defaultLineContainerStyle: {
      flexDirection: 'row',
      width: '100%',
      height: 27,
      backgroundColor:
        Platform.OS === 'web' ? colors.dirtyWhite : colors.titanWhite,
    },
    defaultTickContainerStyle: (tick: number, width: number) => ({
      alignItems: 'center',
      width: tick === 0 ? 0 : width,
      marginRight: Platform.OS === 'web' ? 80 : 19,
    }),
    defaultScaleStyle: {
      marginBottom: 3,
      width: 1,
      height: 5,
      backgroundColor:
        Platform.OS === 'web' ? colors.romanSilver : colors.cornflowerBlue,
    },
    defaultTextStyle: {
      fontSize: 11,
      color: Platform.OS === 'web' ? colors.romanSilver : colors.cornflowerBlue,
      ...typography.interMedium,
    },
  };
};
